export default __webpack_public_path__ + "3c01c11911d54f5d17393435d5e53ef3.png";